import { __awaiter, __decorate } from "tslib";
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import JsxComponent from '@slickdeals/blueprint-twig/javascript/core/jsxComponent';
import CashbackWelcomeModal from './_cashbackWelcomeModal';
import Logger from '@slickdeals/durango/dist/javascript/utilities/logger';
export const name = 'CashbackActivatorModalContextService';
let CashbackActivatorModalContextService = class CashbackActivatorModalContextService {
    initModalContext(heap) {
        this.heap = heap;
        return (JsxComponent.parseJsx(CashbackWelcomeModal, null));
    }
    /**
     * Helper function used to fire a heap impression
     */
    fireHeapEvent() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.heap.track('Rewards No Extension - Intro Interstitial - Impression');
            }
            catch (e) {
                Logger.warn('Error firing heap event');
            }
        });
    }
};
CashbackActivatorModalContextService = __decorate([
    injectable(name)
], CashbackActivatorModalContextService);
export default CashbackActivatorModalContextService;
